import {common} from '@priority-software/priority-proto-api/lib';
import {getServerStoreData, setServerStoreData} from '../../services/proto/ServerStorage/service';
import {
    Action,
    Namespace,
    StoreName,
    getStorageKey
} from '../../services/proto/ServerStorage/utils';
import {BufferData} from './useF9Dialog';
import text from './texts';
export const getCopyBufferKey = () => {
    const key = getStorageKey({
        nameSpace: Namespace.System,
        action: Action.onStorage,
        storage: StoreName.F9
    });
    return key;
};

export const checkKeyId = (keyFromServer: number) => {
    if (keyFromServer >= 99) {
        return 1;
    }
    return keyFromServer ? keyFromServer + 1 : 1;
};

export const getLastKeyId = (
    data: {data: BufferData[]; lastId: string},
    isCopy: boolean
): number => {
    if (isCopy) {
        const maxId = data.data.length ? Math.max(...data.data.map(item => Number(item.id))) : 0;
        return maxId;
    }
    return Number(data.lastId || 0);
};

export const getBufferData = async (): Promise<{data: BufferData[]; lastId: string}> => {
    const key = getCopyBufferKey();
    const data = (await getServerStoreData([key], false, true)) || {};
    return data[key] ? JSON.parse(data[key].Str) : {};
};

export const checkKeyBeforeClose = (serverKey: number, currentKey: number): number => {
    const condition = serverKey === 99 && currentKey === 99;
    return condition ? 99 : currentKey - 1;
};

export const pasteValueToPosition = (inputElement: HTMLInputElement, valueToPaste: string) => {
    // Save the current cursor position
    const startPos = inputElement.selectionStart;
    const endPos = inputElement.selectionEnd;

    // Update the input value by inserting the pasted value at the cursor position
    const currentValue = inputElement.value;
    const newValue = currentValue.slice(0, startPos) + valueToPaste + currentValue.slice(endPos);

    inputElement.focus();

    return newValue;
};

export const resetSaveToBuffer = async () => {
    const key = getCopyBufferKey();
    const valueToBuffer = {
        lastId: 0,
        data: []
    };
    const storeMap = {
        [key]: new common.Constant({Str: JSON.stringify(valueToBuffer)})
    };

    await setServerStoreData(storeMap, true, false);
};
export const setSaveToBuffer = async (
    data: BufferData[] = [],
    idx: string,
    val: string,
    desc?: string
) => {
    const key = getCopyBufferKey();

    const newData = data.filter((item: BufferData) => item.id !== idx);

    const valueToBuffer = {
        lastId: idx,
        data: [{id: idx, value: val, desc}, ...newData]
    };
    const storeMap = {
        [key]: new common.Constant({Str: JSON.stringify(valueToBuffer)})
    };

    await setServerStoreData(storeMap, true, false);
};
export const deleteItemFromBuffer = async (data: BufferData[], idx: string) => {
    const key = getCopyBufferKey();

    const filteredData = data.filter(item => item.id !== idx);

    const valueToBuffer = {
        lastId: idx,
        data: filteredData
    };
    const storeMap = {
        [key]: new common.Constant({Str: JSON.stringify(valueToBuffer)})
    };

    await setServerStoreData(storeMap, true, false);
    return filteredData;
};
type ErrorMsgProps = {data: BufferData[]; value?: string; id?: string};

export const errorMsg = ({data, value, id}: ErrorMsgProps): string => {
    const hasInputValues = value || id;
    if (hasInputValues && data) {
        let msg;
        for (let i = 0; i < data.length; i++) {
            if (data[i].value === value) {
                msg = (text?.value_already_exists_error as string)
                    ?.replace(/X/g, data[i].value)
                    .replace(/Y/g, data[i].id);
                break;
            }

            if (data[i].id === id) {
                msg = (text?.id_already_exists_error as string)?.replace(/X/g, data[i].id);
                break;
            }
        }
        return msg || '';
    }
    return '';
};

(window as any).resetSaveToBuffer = resetSaveToBuffer;
